import React, { useRef, useState } from 'react';
import styled from 'styled-components';

import { useOutsideAlerter } from './useClickOutside';

const getTextForModal = (
  type: 'transcription' | 'subtitles' | 'karaoke breaks',
) => {
  if (type === 'transcription') {
    return 'This will regenerate the transcription and will affect contents of the feature story and all social clips.';
  }
  if (type === 'subtitles') {
    return 'This will regenerate the subtitles, all the edits to it will be lost. Original transcription will not change.';
  }
  return 'This will regenerate new captions. It may affect existing captions text and timings in the video.';
};

export const RegenerateTranscriptionModal: React.FC<{
  type: 'transcription' | 'subtitles' | 'karaoke breaks';
  confirm: () => void;
  discard: () => void;
}> = ({ type, confirm, discard }) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  useOutsideAlerter(wrapperRef, () => discard());
  const [isRegenerating, setIsRegenerating] = useState(false);

  return (
    <Wrapper ref={wrapperRef}>
      <Title>Regenerate {type.at(0)?.toUpperCase() + type.slice(1)}</Title>
      <div
        style={{
          fontSize: 'var(--text-sm)',
          fontWeight: 'var(--font-weight-semibold)',
        }}
      >
        <p>{getTextForModal(type)}</p>
        <p>Are you sure you want to regenerate?</p>
      </div>
      {!isRegenerating && (
        <Buttons>
          <CancelButton onClick={discard}>Cancel</CancelButton>
          <SubmitButton
            onClick={async () => {
              setIsRegenerating(true);
              confirm();
            }}
          >
            Regenerate
          </SubmitButton>
        </Buttons>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: fixed;
  width: 380px;
  height: 200px;
  z-index: 1000;
  margin: auto;
  inset: 0;

  background: var(--popover);
  padding: 10px 25px 20px;
  border: 1px solid gray;
  border-radius: var(--radius-input);
  font-size: var(--text-md);
`;

const Title = styled.p`
  margin: 0;
`;

const Buttons = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

const SubmitButton = styled.button`
  width: 120px;
  font-size: var(--text-md);
  padding: 10px 0;
  background-color: #2a85ff;
  color: var(--foreground);
  border-radius: var(--radius-input);
  border: none;
  cursor: pointer;
}
`;

const CancelButton = styled.button`
  width: 120px;
  font-size: var(--text-md);
  padding: 10px 0px;
  color: var(--foreground);
  border-radius: var(--radius-input);
  background-color: transparent;
  border: 0.5px solid gray;
  cursor: pointer;
}
`;
